import React from 'react';
import { HiOutlineLightningBolt, HiOutlineFilter } from 'react-icons/hi';
import BadgeStatus from '../../../atoms/BadgeStatus';
import { MessageComposition, Routing } from '../../../../types/communication';
import { ChannelTile } from '../composition/shared/channelVisuals';

interface RoutingRowProps {
    routing: Routing;
    metas: MessageComposition[];
    striped: boolean;
    onOpen: () => void;
}

const ENV_SHORT: Record<string, string> = { prd: 'PRD', hml: 'HML', dev: 'DEV', sandbox: 'SBX' };

const RoutingRow: React.FC<RoutingRowProps> = ({ routing, metas, striped, onOpen }) => (
    <tr
        onClick={onOpen}
        className={`${striped ? 'bg-slate-50 dark:bg-slate-800' : 'bg-white dark:bg-slate-900'} border-b border-gray-200 dark:border-slate-700 cursor-pointer hover:bg-teal-50/60 dark:hover:bg-slate-700`}
    >
        <td className="py-2.5 px-2">
            <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-lg bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300 flex items-center justify-center shrink-0">
                    <HiOutlineLightningBolt size={16} />
                </span>
                <div className="min-w-0">
                    <div className="font-mono text-xs font-semibold text-gray-900 dark:text-gray-100 truncate">{routing.event}</div>
                    <div className="text-[11px] text-gray-400 truncate">{routing.ruleId}</div>
                </div>
            </div>
        </td>
        <td className="py-2.5 px-2">
            <div className="flex flex-col gap-1">
                {routing.targets.map((target, index) => {
                    const meta = metas.find((m) => m.id === target.messageCompositionId);
                    return (
                        <span key={index} className="inline-flex items-center gap-2 min-w-0">
                            <ChannelTile channel={target.channel} size="sm" />
                            <span className="text-xs text-gray-700 dark:text-gray-200 truncate">{meta?.description || meta?.name || 'Composição não encontrada'}</span>
                        </span>
                    );
                })}
            </div>
        </td>
        <td className="py-2.5 px-2">
            {routing.conditions.length ? (
                <span className="inline-flex items-center gap-1 text-xs text-gray-600 dark:text-gray-300" title={routing.conditions.map((c) => `${c.jsonPath} = ${c.equals}`).join('\n')}>
                    <HiOutlineFilter size={14} /> {routing.conditions.length}
                </span>
            ) : (
                <span className="text-xs text-gray-400">Sempre</span>
            )}
        </td>
        <td className="py-2.5 px-2">
            <div className="flex flex-wrap gap-1">
                {routing.environments.map((env) => (
                    <span
                        key={env}
                        className={`rounded px-1.5 py-0.5 text-[10px] font-semibold ${
                            env === 'prd' ? 'bg-violet-100 text-violet-800 dark:bg-violet-900/40 dark:text-violet-200' : 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-200'
                        }`}
                    >
                        {ENV_SHORT[env] ?? env}
                    </span>
                ))}
            </div>
        </td>
        <td className="py-2.5 px-2">
            <BadgeStatus color={routing.enabled ? 'green' : 'gray'} text={routing.enabled ? 'Ativo' : 'Inativo'} />
        </td>
    </tr>
);

export default RoutingRow;
